/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { createObservableDataAction, IAction, ICreateActionContext } from '@msdyn365-commerce/core';
import { retailAction } from '@msdyn365-commerce/retail-proxy';
// import { createVSI_AddPorductInterestInput } from '../custom-retail-extension-proxies/DataActionExtension.g';
import { IVSIProductInterest } from '../custom-retail-extension-proxies/DataServiceEntities.g';

export default createObservableDataAction({
    action: <IAction<IVSIProductInterest>>retailAction,
    input: (context: ICreateActionContext) => {
        throw new Error('Unable to call this data action on page load.');
    }
});
